import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class CaseHealthRoute extends BaseRoute {
  @service("repositories/case-health-repository") caseHealthRepository;

  element = (<Template />);
  revalidateOnParams = ["id"];

  async loader({ params }) {
    const { id } = params;

    if (!id || id === "undefined") {
      console.error("Case id not found");
      return { caseHealth: null };
    } else {
      try {
        const caseHealth = await this.caseHealthRepository.query(id);
        return { caseHealth };
      } catch (error) {
        return { caseHealth: null };
      }
    }
  }
}
